module.exports = "<main-header [buttonTextColor]=\"buttonTextColor\" [textColor]=\"textColor\" [backgroundColor]=\"headerBackgroundColor\" [agent]=\"agent\" [image_src]=\"logoImage\"></main-header>\r\n<app-loading-overlay></app-loading-overlay>\r\n<main id=\"main-app\" class=\"main-app\">\r\n  <router-outlet #o=\"outlet\"></router-outlet>\r\n</main>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main